export default "__VITE_ASSET__BzUk1zsa__"